// 브라우저(=업로드 소유자)마다 고정되는 불투명 세션 토큰. dataset-import lease의 소유자를
// 식별한다(공유 계약 §3.1). 토큰은 localStorage에 보관한다. storage가 없는 환경(SSR/Node)에서는
// 메모리 fallback으로 같은 런타임 세션 안에서 같은 값을 유지한다.

const STORAGE_KEY = "hatchery-registry:upload-session-token:v1";

// storage가 없는 환경(테스트/SSR) 전용 fallback. storage를 쓸 수 있으면 사용하지 않는다.
let memoizedToken: string | null = null;

function readStoredToken(): string | null {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value !== null && value.length > 0 ? value : null;
  } catch {
    return null;
  }
}

function persistToken(token: string): boolean {
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
    return true;
  } catch {
    // storage를 쓸 수 없거나 쿼터를 넘으면 무시한다. 메모리 fallback으로 세션 안에서만 값을 유지한다.
    return false;
  }
}

// 브라우저 고정 세션 토큰을 반환한다. 없으면 UUID v4를 생성해 저장한다(공유 계약 §3.1, ≤64자).
export function getUploadSessionToken(): string {
  const stored = readStoredToken();
  if (stored !== null) {
    return stored;
  }
  if (memoizedToken !== null) {
    // storage를 쓸 수 없는 환경에서만 여기에 도달한다.
    return memoizedToken;
  }
  const token = crypto.randomUUID();
  if (!persistToken(token)) {
    memoizedToken = token;
  }
  return token;
}
